// extracted by mini-css-extract-plugin
module.exports = {"root":"Auth_root__2-oaG","input":"Auth_input__3dnNF","underButton":"Auth_underButton__6gB_v","link":"Auth_link__3U9Vm"};